import * as API from "./index";

export default {
  getApkInfo: (params) => {
    return API.GET("/admin/version/getOfficialWebsiteApp", params);
  },
};
